import React from "react";
import FilterRow from "./FilterRow";
import {FaBuilding, FaGlobe} from "react-icons/fa";

export const CrawlScopeFilters = ({handleSwitchToggle, state}) => {
    const t = state.toggles;
    return (
        <FilterRow
            label="Crawl scope"
            items={[
                {label: "Internal", icon: FaBuilding, color: "#20c997", checked: t.crawlInternalChecked, onChange: handleSwitchToggle("crawlInternalChecked"), key: "internal"},
                {label: "External", icon: FaGlobe, color: "#0056b3", checked: t.crawlExternalChecked, onChange: handleSwitchToggle("crawlExternalChecked"), key: "external"}
            ]}
        />
    );
};
